module.exports = __webpack_public_path__ + "img/news.1c542870.svg";